import { IProjectDetailsDTO } from '@/modules/projects/dtos/project.dto';
import { IProjectDetails } from '@/modules/projects/entities/project.entity';

export class ProjectDetailsMapper {
  public static toPresentation(projectDetails: IProjectDetailsDTO): IProjectDetails {
    return {
      id: projectDetails.id,
      name: projectDetails.nome,
      description: projectDetails.descricao,
      createdAt: projectDetails.createdAt,
      updatedAt: projectDetails.updatedAt,
      role: {
        id: projectDetails.cargo.id,
        name: projectDetails.cargo.nome,
      },
    };
  }

  public static toDTO(projectDetails: IProjectDetails): IProjectDetailsDTO {
    return {
      id: projectDetails.id,
      nome: projectDetails.name,
      descricao: projectDetails.description,
      cargo: {
        id: projectDetails.role.id,
        nome: projectDetails.role.name,
      },
      createdAt: projectDetails.createdAt,
      updatedAt: projectDetails.updatedAt,
    };
  }
}
